/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_2_DetailInputs */

const en_services_svc_money_art_2_detail = /** @type {(inputs: Services_Svc_Money_Art_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website, news and fit checked`)
};

const lv_services_svc_money_art_2_detail = /** @type {(inputs: Services_Svc_Money_Art_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudīta mājaslapa, ziņas un atbilstība`)
};

/**
* | output |
* | --- |
* | "Website, news and fit checked" |
*
* @param {Services_Svc_Money_Art_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_2_detail = /** @type {((inputs?: Services_Svc_Money_Art_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_2_detail(inputs)
	return en_services_svc_money_art_2_detail(inputs)
});